// import { unitSymobol } from "../utils/utils";
// import React, { useMemo, useState } from "react";
// import moment from "moment";

// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     TimeScale,
//     Title,
//     Tooltip,
//     Legend,
// } from 'chart.js'
// import { Line } from 'react-chartjs-2'

// ChartJS.register(
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     TimeScale,
//     LineElement,
//     Title,
//     Tooltip,
//     Legend
// )
// function TodayLineGraph({
//     datas,
//     unit,
//     timestamps,
//     id,
//     type,
//     setClickedElement,
// }) {
//     const dateFormat = "DD MMM YYYY";
//     const timeFormat = "LT"
//     const maxCalculations = (type) => {
//         if (type.toLowerCase().includes('temperature'))
//             return 40
//         else if (type.toLowerCase().includes('humidity'))
//             return 100
//         else if (type.toLowerCase().includes('water sense'))
//             return 2
//         else if (type.toLowerCase().includes('water'))
//             return 120


//         return 100
//     }

//     return (
//         <Line id={id}

//             data={datas}
//             options={{
//                 responsive: true,
//                 maintainAspectRatio: false,
//                 plugins: {
//                     legend: {
//                         display: false,
//                     },
//                     datalabels: {
//                         display: false,
//                     },
//                     tooltip: {
//                         callbacks: {
//                             label: (item) => {
//                                 return item.raw + ' ' + (unit ? unitSymobol(unit) : "")
//                             }
//                         }
//                     },
//                 },
//                 elements: {
//                     point: {
//                         radius: 0,
//                     }
//                 },
//                 layout: {
//                     padding: {
//                         left: 0,
//                         right: 0,
//                         top: 10,
//                         bottom: 0,
//                     },
//                 },
//                 interaction: {
//                     mode: 'index',
//                     intersect: false
//                 },
//                 scales: {
//                     x: {
//                         type: "time",
//                         time: {
//                             displayFormats: {
//                                 quarter: "MMM YYYY",
//                             },
//                             tooltipFormat: "lll",
//                             unit: "hour",
//                             minUnit: "hour",
//                         },
//                         ticks: {
//                             font: {
//                                 weight: 'bold'
//                             },
//                             stepSize: 1,
//                             padding: 10
//                         }
//                     },

// //                     x: {
// //     type: "time",
// //     time: {
// //         displayFormats: {
// //             quarter: "MMM YYYY",
// //         },
// //         tooltipFormat: "lll",
// //         unit: "hour",
// //         minUnit: "hour",
// //     },
// //     ticks: {
// //         font: {
// //             weight: 'bold'
// //         },
// //         stepSize: 1,
// //         padding: 10,
// //         callback: function (value, index, ticks) {
// //             const hour = moment(value).hour();
// //             const displayHour = hour % 12 === 0 ? 12 : hour % 12;
// //             return displayHour;
// //         }
// //     },
// //     title: {
// //         display: true,
// //         text: (ctx) => {
// //             const first = ctx.chart.scales.x.min;
// //             const last = ctx.chart.scales.x.max;

// //             const firstHour = moment(first).hour();
// //             const lastHour = moment(last).hour();

// //             if (firstHour < 12 && lastHour >= 12) return "AM                      PM";
// //             if (lastHour < 12) return "AM";
// //             return "PM";
// //         },
// //         font: {
// //             weight: "bold",
// //             size: 14
// //         },
// //         padding: {
// //             top: 12
// //         }
// //     }
// // },

//                     y: {
//                         position: 'right',
//                         beginAtZero: true,
//                         max: maxCalculations(type),
//                         ticks: {
//                             callback: function (value, index, values) {
//                                 return value + ' ' + (unit ? unitSymobol(unit) : "");
//                             },
//                         },
//                     }
//                 },
//             }}
//         />
//     )
// }

// export default TodayLineGraph


import { unitSymobol } from "../utils/utils";
import React, { useRef, useEffect } from "react";
import moment from "moment";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    TimeScale,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    TimeScale,
    LineElement,
    Title,
    Tooltip,
    Legend
);

function TodayLineGraph({
    datas,
    unit,
    timestamps,
    id,
    type,
    setClickedElement,
}) {
    const chartRef = useRef(null);

    useEffect(() => {
        const chart = chartRef.current;
        
        if (chart) {
            console.log("Chart instance found:", chart);
            
            // Force a redraw
            chart.update();
        }
    }, [datas]);

    const maxCalculations = (type) => {
        if (type.toLowerCase().includes("temperature")) return 40;
        else if (type.toLowerCase().includes("humidity")) return 100;
        else if (type.toLowerCase().includes("water sense")) return 2;
        else if (type.toLowerCase().includes("water")) return 120;
        return 100;
    };

    // Plugin defined inside component
    const ampmPlugin = {
        id: "ampmPlugin",
        afterDraw: (chart) => {
            console.log("=== AM/PM Plugin Called ===");
            
            const ctx = chart.ctx;
            const xScale = chart.scales.x;
            const chartArea = chart.chartArea;

            if (!xScale || !chartArea) {
                console.log("Missing scale or chart area");
                return;
            }

            console.log("Chart area:", chartArea);

            // Get the scale's min and max timestamps
            const scaleMin = xScale.min;
            const scaleMax = xScale.max;
            
            // Calculate noon based on the data's day
            const dataDate = moment(scaleMin).startOf('day');
            const noonTime = dataDate.clone().hour(12).valueOf();
            
            console.log("Times - Min:", new Date(scaleMin), "Max:", new Date(scaleMax), "Noon:", new Date(noonTime));

            // Get pixel positions
            const leftPixel = chartArea.left;
            const rightPixel = chartArea.right;
            const noonPixel = xScale.getPixelForValue(noonTime);

            console.log("Pixels - Left:", leftPixel, "Noon:", noonPixel, "Right:", rightPixel);

            // Position below the chart
            const yPos = chartArea.bottom + 40;

            ctx.save();

            // Draw AM section (red)
            ctx.strokeStyle = "#ff4444";
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.moveTo(leftPixel, yPos);
            ctx.lineTo(noonPixel, yPos);
            ctx.stroke();

            // Draw PM section (blue)
            ctx.strokeStyle = "#4444ff";
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.moveTo(noonPixel, yPos);
            ctx.lineTo(rightPixel, yPos);
            ctx.stroke();

            // Draw AM text
            ctx.font = "bold 12px Arial";
            ctx.fillStyle = "#ff4444";
            ctx.textAlign = "center";
            ctx.textBaseline = "top";
            const amCenter = (leftPixel + noonPixel) / 2;
            ctx.fillText("AM", amCenter, yPos + 8);

            // Draw PM text
            ctx.fillStyle = "#4444ff";
            const pmCenter = (noonPixel + rightPixel) / 2;
            ctx.fillText("PM", pmCenter, yPos + 8);

            console.log("Drew labels at AM:", amCenter, "PM:", pmCenter);

            ctx.restore();
        },
    };

    return (
        <Line
            ref={chartRef}
            id={id}
            data={datas}
            options={{
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    datalabels: { display: false },
                    ampmPlugin: {},
                },
                elements: {
                    point: { radius: 0 },
                },
                layout: {
                    padding: { left: 0, right: 0, top: 10, bottom: 30 },
                },
                interaction: { mode: "index", intersect: false },
                scales: {
                    x: {
                        type: "time",
                        time: {
                            displayFormats: { quarter: "MMM YYYY" },
                            tooltipFormat: "lll",
                            unit: "hour",
                            minUnit: "hour",
                        },
                        // ticks: {
                        //     font: { weight: "bold" },
                        //     stepSize: 1,
                        //     padding: 10,
                        //     callback: function (value) {
                        //         const hour = moment(value).hour();
                        //         return hour === 0 ? 24 : hour;
                        //     },
                        // },

                        ticks: {
                            font: { weight: "bold" },
                            stepSize: 1,
                            padding: 10,
                            callback: function (value) {
                                return moment(value).format("h"); 
                            },
                            },
                    },
                    y: {
                        position: "right",
                        beginAtZero: true,
                        max: maxCalculations(type),
                        ticks: {
                            callback: (value) =>
                                value +
                                " " +
                                (unit ? unitSymobol(unit) : ""),
                        },
                    },
                },
            }}
            plugins={[ampmPlugin]}
        />
    );
}

export default TodayLineGraph;
